const BrandMark = ({ size = 36 }) => (
  <svg width={size} height={size * 0.93} viewBox="0 0 100 93" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Nthra Labs logo">
    <defs>
      <linearGradient id="logoGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#0D6E7A"/>
        <stop offset="100%" stopColor="#00C9A7"/>
      </linearGradient>
    </defs>
    <rect x="6" y="8" width="15" height="77" rx="2.5" fill="url(#logoGrad)"/>
    <polygon points="21,8 36,8 72,77 72,85 57,85 21,20" fill="url(#logoGrad)"/>
    <rect x="57" y="8" width="15" height="77" rx="2.5" fill="url(#logoGrad)"/>
  </svg>
);

export default BrandMark;
